import { z } from 'zod';
import { IANAZone } from 'luxon';
/** Trailing windows (days, on sent date) the email performance page can show */
export const EMAIL_PERFORMANCE_DAYS = [30, 90, 180, 365];
export const emailPerformanceQuerySchema = z.object({
    days: z.coerce.number()
        .pipe(z.union([z.literal(30), z.literal(90), z.literal(180), z.literal(365)]))
        .default(90),
    /** IANA zone for the send-time heatmap. Defaults to the organisation timezone */
    timezone: z.string().trim().min(1)
        .refine(zone => IANAZone.isValidZone(zone), `timezone must be a valid IANA zone`)
        .optional(),
});
//# sourceMappingURL=emailPerformance.js.map